export default __webpack_public_path__ + "static/media/smile.a9c4a4d2.svg";